import DashboardsHome from './table';

export default DashboardsHome;
